import { PilotJobOrder, PilotJobOrderOptions } from 'data/models/PilotJobOrder';
import { ReqChangeId, makePITKey, makePITDataKey } from './PITUtils';

export type PilotJobOrderPITOptions = ReqChangeId<PilotJobOrderOptions>;
export const PilotJobOrderPITKey = makePITKey<PilotJobOrder>(PilotJobOrder.key);
export const PilotJobOrderPITDataKey = makePITDataKey<PilotJobOrderOptions>(PilotJobOrder.dataKey);



// WEBPACK FOOTER //
// ./data/models/PilotJobOrderPIT.ts